import { useState } from 'react';
import { diffNotificationLevels, withPerimeterFallback } from 'components/perimeter/memberNotifications';
import useMemberNotifications from './useMemberNotifications';

// errorCode of the notifications route → text key under
// companyContacts.edit.notifications.errors.
export const NOTIFICATION_ERROR_KEYS = {
  PERIMETER_FORBIDDEN: 'forbidden',
  INVALID_PERIMETER_ID: 'companyNotFound',
  COMPANY_NOT_FOUND: 'companyNotFound',
  PERIMETER_MEMBER_INVALID: 'memberInvalid',
  NOTIFICATION_TYPE_INVALID: 'typeInvalid',
  NOTIFICATION_LEVEL_INVALID: 'levelInvalid',
};

/**
 * A member's notification levels as the table shows them: the levels read,
 * with the subjects the admin touched on top (`change`). The api reads 'all'
 * where a Director or an Administrator stores 'perimeter'
 * (`isPerimeterLevelBlocked`): the table shows it ahead, and `patch` only
 * holds what the admin changed on top — empty while the levels are not read,
 * so that an unknown state is never overwritten. `markSaved(answer)` takes
 * the api's answer to a save as the member's state.
 */
const useMemberNotificationsDraft = (idCompany, idEmployee, isPerimeterLevelBlocked) => {
  const memberNotifications = useMemberNotifications(idCompany, idEmployee);
  const [draft, setDraft] = useState({});
  const [error, setError] = useState('');

  const applyPerimeterRule = (levels) => (isPerimeterLevelBlocked ? withPerimeterFallback(levels) : levels);
  const isReady = memberNotifications.status === 'ready';
  const shownLevels = isReady ? applyPerimeterRule({ ...memberNotifications.levels, ...draft }) : null;
  const patch = isReady ? diffNotificationLevels(applyPerimeterRule(memberNotifications.levels), shownLevels) : {};

  const change = (type, level) => {
    setError('');
    setDraft((previous) => ({ ...previous, [type]: level }));
  };
  const markSaved = (answer) => {
    setDraft({});
    memberNotifications.setSavedLevels(answer);
  };

  return {
    status: memberNotifications.status,
    reload: memberNotifications.reload,
    shownLevels,
    patch,
    change,
    error,
    setError,
    markSaved,
  };
};

export default useMemberNotificationsDraft;
